import { RmcrType } from './rmcr-type';

export interface IScoreCard {
    type: RmcrType,
    isBillable: boolean,
    isWaived: boolean,
    isMajor: boolean,
    expectedFee: number,
    isCompliant: boolean,
    description: string,
    helpText?: string,
    link?: string,
    required?: string,
    decimalValue: number,
    denominator: number,
    value: string
}